export const MAX_PAYMENT_CARDS = 6;

export const CARD_NAME_MAX_LENGTH = 18;
